import React from 'react';
import { Column, ContentModal, Header, Main, MainHeader, MarkdownContent, Row } from './aboutModal.styles';
import { PartnersList } from '../partnersList/partnersList.component';
import { useIntl } from 'gatsby-plugin-intl';
export const AboutModal = ({ logoList }) => {
  const intl = useIntl();
  return (
    <ContentModal>
      <Row>
        <Column main>
          <MainHeader>{intl.formatMessage({ id: 'About' })}</MainHeader>
          <Main main noBorder>
            <MarkdownContent short>
              {`# ${intl.formatMessage({
                id:
                  'The Global Report on Public Financial Management was prepared by the PEFA Secretariat in consultation with a wider group of stakeholders.',
              })}`}
            </MarkdownContent>
          </Main>
        </Column>
      </Row>
      <Row>
        <Column>
          <Header>{intl.formatMessage({ id: 'Executive summary' })}</Header>
          <Main>
            <MarkdownContent>
              {intl.formatMessage({
                id: `The Global Report presents trends in public financial management (PFM) using Public Expenditure and Financial Accountability (PEFA) data. The report, which is only available online, contains data visualizations accompanied by short analyses and country examples that highlight key trends in PFM across seven key areas of the budget cycle. The analysis presented in this current publication is based on the data from 607 national and subnational PEFA assessments published between 2005 and 2021. Considering the significant challenges that the ongoing COVID-19 pandemic is creating for PFM performance, the 2022 publication of the Global Report includes a featured overview of crisis budgeting tools and trends. It also presents three case studies that demonstrate how PEFA assessment findings can be used to give insights into the readiness of PFM systems to respond to crises: Colombia, Mongolia, and Seychelles. Finally, the report presents ideas on how the data analysis and findings could influence future research on PFM. The previous 2020 Global Report can be accessed [here](https://www.pefa.org/global-report-2020/en/?current=/home).`,
              })}
            </MarkdownContent>
          </Main>
        </Column>
        <Column>
          <Header>{intl.formatMessage({ id: 'Key messages' })}</Header>
          <Main>
            <MarkdownContent>
              {intl.formatMessage({
                id: `- Globally, PFM systems struggle where it matters most for efficient service delivery: budget execution. This undermines the potential benefits of stronger performance at the budget preparation stage. \n- Public access to fiscal information, fiscal risk reporting, public investment and public asset management, and expenditure arrears management are emerging as the weakest areas of PFM. \n- The budget preparation process, predictability of in-year resource allocation, internal controls on non-salary expenditure, and debt management continue to be the highest-scoring areas of PFM.\n- Existing paradoxes warrant more research on interactions between various parameters of PFM. For example, countries score highly on debt management against a background of weak public investment management and ballooning public debt globally.\n- The COVID-19 pandemic revealed that many PFM systems were not sufficiently resilient, which contributed to the widespread adoption of crisis budgeting measures.\n- During a crisis, PFM systems must find the appropriate balance between flexibility and accountability.\n- PEFA reports provide a valuable basis for conducting broad assessments of the readiness of countries’ PFM systems to respond to crises.\n`,
              })}
            </MarkdownContent>
          </Main>
        </Column>
      </Row>
      <Row>
        <Column>
          <Header>{intl.formatMessage({ id: 'Content and data analysis' })}</Header>
          <Main>
            <MarkdownContent>
              {intl.formatMessage({
                id: `The Global Report was prepared by a PEFA Secretariat team led by Richard Sutherland and Helene Magnier. The core team was composed of Zachary Mills and Sophia Whyte-Givans, while Srinivas Gurazada (Head, PEFA Secretariat) provided strategic leadership. Furthermore, the report benefited from valuable inputs from Antonio Blasco, Ashikur Rahman, Helena Ramos, Holy-Tiana Rame, Julia Dhimitri, Nouf Alazmi, Tia Raappana, and Silvia Kirova of the PEFA Secretariat. Finally, Bertin Lopez and Nene Mane provided the team with administrative support, while Jose Carlos Ferreyra and Ritesh Sanan assisted with the technological aspects of the Report. \n\nThe Global Report is a result of the strategic support and inputs from the nine PEFA partners, namely the European Commission, International Monetary Fund, World Bank, and the governments of France, Luxembourg, Norway, Slovak Republic, Switzerland, and the United Kingdom. In particular, the report benefitted from the leadership and technical guidance of the following PEFA Steering Committee members: Edward Olowo-Okere (Global Director, World Bank), who Chaired the Quality Enhancement Review for the Report, Adenike Oyeyiola (Practice Manager, World Bank), who provided overall guidance for the development of the Report, and Vincent Tang and Alan Whitworth, who provided constructive comments on behalf of the International Monetary Fund and the United Kingdom's Foreign, Commonwealth & Development Office, respectively. The team is also grateful for the helpful peer review comments provided by Gabriele Buchholz (Osnabrueck University of Applied Sciences) and Jens Kromann Kristensen, Chiara Bronchi, Badamchimeg Dondog, David Santos, Patrick Kabuya, and Ruxandra Burdescu (World Bank). \n`,
              })}
            </MarkdownContent>
          </Main>
        </Column>
        <Column>
          <Row>
            <Column noMargin>
              <Header>{intl.formatMessage({ id: 'Copyedit' })}</Header>
              <Main>
                <span>Patricia Carley</span>
              </Main>
            </Column>
          </Row>
          <Row>
            <Column>
              <Header>{intl.formatMessage({ id: 'Design & Development' })}</Header>
              <Main>
                <span>Schema Design</span>
              </Main>
            </Column>
          </Row>
          <Row>
            <Column>
              <Header>{intl.formatMessage({ id: 'Contact' })}</Header>
              <Main>
                <span><a href="mailto:contact@pefa.org">contact@pefa.org</a></span>
              </Main>
            </Column>
          </Row>
        </Column>
      </Row>
      <PartnersList {...logoList} />
    </ContentModal>
  );
};